import React, { useEffect, useState } from 'react';
import { loadActivityRows } from '../services/activityLog';

const th = { textAlign: 'left', padding: '8px 10px', fontSize: 12, color: '#5B6270', fontWeight: 700, borderBottom: '1px solid #e7dfcc' };
const td = { padding: '10px', fontSize: 14, borderBottom: '1px solid #f0ead8' };

export default function ActivityTab() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = () => {
    setLoading(true); setError('');
    loadActivityRows()
      .then(setRows)
      .catch((err) => { console.error('Could not load activity', err); setError('Could not load activity.'); })
      .finally(() => setLoading(false));
  };
  useEffect(load, []);

  const fmt = (iso) => (iso ? new Date(iso).toLocaleString() : 'Never');

  return (
    <div style={{ background: '#FFFFFF', border: '1px solid #e7dfcc', borderRadius: 8, padding: 16 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8, marginBottom: 8 }}>
        <h2 style={{ margin: 0, fontSize: 18 }}>Team activity</h2>
        <button type="button" onClick={load} disabled={loading}
          style={{ padding: '6px 12px', borderRadius: 6, border: '1px solid #B8962E', background: '#FFFFFF', color: '#8C6D1F', fontWeight: 700, cursor: 'pointer' }}>
          {loading ? 'Loading...' : 'Refresh'}
        </button>
      </div>
      <p style={{ margin: '0 0 12px', fontSize: 13, color: '#5B6270' }}>
        Last 30 days. Open and overdue counts are for the deals each person owns.
      </p>
      {error && <p style={{ color: '#D64545', fontSize: 13 }}>{error}</p>}
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 720 }}>
          <thead>
            <tr>
              <th style={th}>Name</th>
              <th style={th}>Role</th>
              <th style={th}>Last login</th>
              <th style={th}>Days logged in</th>
              <th style={th}>Tasks completed</th>
              <th style={th}>Open tasks</th>
              <th style={th}>Overdue</th>
              <th style={th}>Points</th>
              <th style={th}>Streak (days)</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.uid}>
                <td style={{ ...td, fontWeight: 600 }}>{r.name}</td>
                <td style={td}>{r.role || '-'}</td>
                <td style={td}>{fmt(r.lastLogin)}</td>
                <td style={td}>{r.loginDays30}</td>
                <td style={td}>{r.completed30}</td>
                <td style={td}>{r.open}</td>
                <td style={{ ...td, color: r.overdue ? '#D64545' : '#1A1A1A', fontWeight: r.overdue ? 700 : 400 }}>{r.overdue}</td>
                <td style={{ ...td, fontWeight: 700, color: '#8C6D1F' }}>{r.points}</td>
                <td style={td}>{r.streak}</td>
              </tr>
            ))}
            {!loading && rows.length === 0 && (
              <tr><td style={td} colSpan={9}>No users yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
